export default __webpack_public_path__ + "static/media/DSC_0581.5c595e78.jpg";